
const partPoFields = [
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
  {
    title: 'Status',
    field: 'statusName',
  },
  {
    title: 'Part',
    field: 'partNumber',
  },
  {
    title: 'Ordered',
    field: 'quantity',
  },
  {
    title: 'On-Hand',
    field: 'onHand',
  },
  {
    title: 'Available',
    field: 'available',
  },
  {
    title: 'Req Test',
    field: 'requiresTesting',
  },
  {
    title: 'Qty To Test',
    field: 'qtyToTest',
    cell: 'formatNumberField',
    sortable: false,
    hidden: false,
    width: 150,
  },
  {
    title: 'Warehouse',
    field: 'warehouseName',
  },
  {
    title: 'Location',
    field: 'location',
  },
];

export default partPoFields;
